//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faSparkle } from '@fortawesome/pro-solid-svg-icons';
import channelTypesMixin from '@motionelements/core/src/components/mixins/channelTypes.mixin.js';

export default {
  name: 'media-types-menu',
  mixins: [channelTypesMixin],
  components: {
    NavLink: () => import('./NavLink.vue'),
    ProductIcon: () => import('@motionelements/core/src/components/product/ProductIcon.vue'),
  },
  data() {
    return {
      faSparkle,
    };
  },
  methods: {
    mediaTypeTitle(channelTypeId) {
      return this.getChannelTypeName(channelTypeId);
    },
  },
};
